module.exports = __webpack_public_path__ + "static/tree-b6889f330615c42f901b326c3efcc4b0.png";